<div class="alima-sidebar flex flex-column h-full">

  <!-- Header : Logo -->
  <div class="sidebar-header flex align-items-center px-3 flex-shrink-0">
    <span class="lexend font-bold text-2xl text-white tracking-wide">alima
      <span class="text-sm sidebar-text-muted">by finappli</span>
    </span>
  </div>

  <!-- Menu Items -->
  <div class="overflow-y-auto flex flex-column mt-2 px-2 pb-2">

    <!-- Section PRINCIPAL -->
    <div class="sidebar-section-label px-2 mb-1">
      <span>PRINCIPAL</span>
    </div>

    <a routerLink="account" routerLinkActive="active" class="sidebar-link">
      <i class="pi pi-address-book mr-2"></i>
      <span class="font-medium text-sm">Comptes</span>
    </a>
    <a routerLink="operation" routerLinkActive="active" class="sidebar-link">
      <i class="pi pi-clipboard mr-2"></i>
      <span class="font-medium text-sm">Op&eacute;rations</span>
    </a>
    <a routerLink="bank" routerLinkActive="active" class="sidebar-link">
      <i class="pi pi-building-columns mr-2"></i>
      <span class="font-medium text-sm">Banques</span>
    </a>
    <a routerLink="devise" routerLinkActive="active" class="sidebar-link">
      <i class="pi pi-euro mr-2"></i>
      <span class="font-medium text-sm">Devises</span>
    </a>
    <a routerLink="cash-register" routerLinkActive="active" class="sidebar-link">
      <i class="pi pi-wallet mr-2"></i>
      <span class="font-medium text-sm">Caisses</span>
    </a>

    <!-- Section ADMINISTRATION -->
    <div class="sidebar-section-label px-2 mt-3 mb-1">
      <span>ADMINISTRATION</span>
    </div>

    <a *hasRole="'READ_INSTITUTION'" routerLink="institution" routerLinkActive="active" class="sidebar-link">
      <i class="pi pi-home mr-2"></i>
      <span class="font-medium text-sm">Institutions</span>
    </a>
    <a *hasRole="'READ_USER'" routerLink="user" routerLinkActive="active" class="sidebar-link">
      <i class="pi pi-users mr-2"></i>
      <span class="font-medium text-sm">Utilisateurs</span>
    </a>
    <a *hasRole="'READ_GROUP'" routerLink="group" routerLinkActive="active" class="sidebar-link">
      <i class="pi pi-link mr-2"></i>
      <span class="font-medium text-sm">Groupes</span>
    </a>
    <a *hasRole="'READ_LOG'" routerLink="log" routerLinkActive="active" class="sidebar-link">
      <i class="pi pi-info-circle mr-2"></i>
      <span class="font-medium text-sm">Logs</span>
    </a>
    <a routerLink="profile" routerLinkActive="active" class="sidebar-link">
      <i class="pi pi-cog mr-2"></i>
      <span class="font-medium text-sm">Param&egrave;tres</span>
    </a>
  </div>

  <!-- Footer -->
  <div class="mt-auto flex flex-column w-full">
    <div class="sidebar-footer p-2 flex align-items-end w-full">
      <div class="sidebar-logout-btn flex align-items-center cursor-pointer gap-2 border-round w-full p-2"
           (click)="logout()">
        <div class="sidebar-avatar flex align-items-center justify-content-center border-circle w-2rem h-2rem flex-shrink-0">
          <span class="font-bold text-sm text-white">{{ username.charAt(0).toUpperCase() }}</span>
        </div>
        <div class="flex flex-column overflow-hidden">
          <span class="font-bold text-sm white-space-nowrap text-overflow-ellipsis sidebar-text-primary">{{ username.toUpperCase() }}</span>
          <span class="text-xs white-space-nowrap text-overflow-ellipsis sidebar-text-muted">{{ institution }}</span>
        </div>
        <i class="pi pi-sign-out ml-auto sidebar-logout-icon"></i>
      </div>
    </div>
  </div>
</div>
